import React, { FC, useEffect } from 'react';

import {
  Main,
  MainContent,
  MainH1Title,
  NewsWrap,
  Wrap,
  WrapSP,
} from 'modules/main/pages/styles/TagWikiPersonalPage/style';

// UI
import { LoadAnchor } from 'ui/LoadAnchor';

// Layouts
import { SiteWrap } from 'modules/main/layouts/SiteWrap';

// Components
import { ContentBanner } from 'modules/main/components/ContentBanner';
import { SpecialProjects } from 'modules/main/layouts/SpecialProjects';
import { SectionTitle } from './components/SectionTitle';

// Hooks
import { useGetBeautyArticles } from 'api/articlesBeautypedia/useGetBeautyArticles';
import { useGetBlocks } from 'api/blocks/useGetBlocks';
import { useTranslations } from 'languages';
import BeautypediaArticle from 'modules/main/components/Beautypedia/BeautypediaArticle';
import { useRouter } from 'next/router';
import { useProContext } from 'store/ProReducer/useProContext';
import { TagWikiLayoutPropsType } from 'types/pages/TagWikiPersonal';
import { useBannerPosition } from 'utils/hooks/useBannerPosition/useBannerPosition';
import { useGetCurrentCapitalizeTitle } from 'utils/hooks/useGetCurrentCapitalizeTitle';
import { useLoadAnchor } from 'utils/hooks/useLoadAnchor';

export const TagWikiLayout: FC<TagWikiLayoutPropsType> = ({
  tagWikiData,
  metaTagWiki,
  siteText,
}) => {
  const t = useTranslations();

  const { modulId } = useProContext();

  const { locale = '' } = useRouter();

  const { pagesArr, anchorRef, setRequestParams } = useLoadAnchor(useGetBeautyArticles);
  const { data: blockData } = useGetBlocks({ modulId, lang: locale });
  const { dataBanner, numberBannerFirst, numberBannerSecond } = useBannerPosition(
    blockData,
    false
  );

  const { id = '', seo } = { ...tagWikiData[0] };

  useEffect(() => {
    setRequestParams({
      tag_id: id,
      page: 1,
      modulId,
    });
  }, [id]);

  const { title_ru = '', title_uk = '', title_en = '' } = { ...seo };
  // @ts-ignore
  const tagForH1Title = useGetCurrentCapitalizeTitle({ title_ru, title_uk, title_en });

  return (
    <SiteWrap articleMeta={metaTagWiki} isArticle articleData={seo} noindex anons={''}>
      <Main siteText={siteText}>
        <MainContent>
          <MainH1Title>{tagForH1Title}</MainH1Title>
          <NewsWrap>
            {pagesArr.map((data, i) => {
              return (
                <React.Fragment key={i}>
                  {i === 6 && (
                    <Wrap>
                      <ContentBanner modulId={modulId} count="numberBannerFirst" />
                      <WrapSP>
                        <SectionTitle>{t('specialProjects')}</SectionTitle>
                        <SpecialProjects />
                      </WrapSP>
                      <ContentBanner modulId={modulId} count="numberBannerSecond" />
                    </Wrap>
                  )}
                  <BeautypediaArticle data={data} />
                </React.Fragment>
              );
            })}
            <LoadAnchor ref={anchorRef} />
          </NewsWrap>
        </MainContent>
      </Main>
    </SiteWrap>
  );
};
